export default "__VITE_ASSET__99c0c96e__"